<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p>
<div class="fmh1">Table of Contents</div>
<div> <br/></div>
<div class="cfmh"><a href="#/ande_9781118039977_oeb_tp_r1">Title Page</a></div>
<div class="cbmh"><a href="#/ande_9781118039977_oeb_cop_r1">Copyright Page</a></div>
<div class="cfmh"><a href="#/ande_9781118039977_oeb_prf_r1">PREFACE</a></div>
<div class="ch1"><a href="#/ande_9781118039977_oeb_prf_r1#h1">MCMILLAN|DOOLITTLE: A BRIEF HISTORY</a></div>
<div class="ch1"><a href="#/ande_9781118039977_oeb_prf_r1#h2">MCMILLAN|DOOLITTLE’S POINT OF VIEW</a></div>
<div class="cfmh"><a href="#/ande_9781118039977_oeb_ack_r1">Acknowledgments</a></div>
<div> <br/></div>
<div class="cpt"><a href="#/ande_9781118039977_oeb_p01_r1">PART I - The Theory</a></div>
<div> <br/></div>
<div class="cct"><a href="#/ande_9781118039977_oeb_c01_r1">CHAPTER ONE - EST: A COMPASS TO AVOID RETAIL’S BLACK HOLE</a></div>
<div> <br/></div>
<div class="ch1"><a href="#/ande_9781118039977_oeb_c01_r1#h1">EST DEFINED</a></div>
<div class="ch1"><a href="#/ande_9781118039977_oeb_c01_r1#h2">EST IS NOT A MARKETING TOOL</a></div>
<div class="ch1"><a href="#/ande_9781118039977_oeb_c01_r1#h3">THE INTRODUCTION OF EST</a></div>
<div class="ch1"><a href="#/ande_9781118039977_oeb_c01_r1#h4">DOES EST CHANGE? ABSOLUTELY</a></div>
<div class="ch1"><a href="#/ande_9781118039977_oeb_c01_r1#h5">PUTTING EST TO WORK</a></div>
<div class="ch1"><a href="#/ande_9781118039977_oeb_c01_r1#h6">THE PROOF IS IN THE RESULTS</a></div>
<div> <br/></div>
<div class="cct"><span href="#/ande_9781118039977_oeb_c02_r1" title="Link target outside of Sample">CHAPTER TWO - CUSTOMERS ARE #1 Now It’s Time for Retailers to Start Treating  ...</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c02_r1#h1" title="Link target outside of Sample">THE MYTHS OF CUSTOMER SERVICE</span></div>
<div> <br/></div>
<div class="cpt"><span href="#/ande_9781118039977_oeb_p02_r1" title="Link target outside of Sample">PART II - The Practice</span></div>
<div class="cct"><span href="#/ande_9781118039977_oeb_c03_r1" title="Link target outside of Sample">CHAPTER THREE - CHEAP-EST: WINNING WITH PRICE</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c03_r1#h1" title="Link target outside of Sample">CHEAP-EST DEFINED</span></div>
<div> <br/></div>
<div class="cct"><span href="#/ande_9781118039977_oeb_c04_r1" title="Link target outside of Sample">CHAPTER FOUR - BIG-EST: WINNING WITH DOMINANT ASSORTMENTS</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c04_r1#h1" title="Link target outside of Sample">ARE CATEGORY KILLERS STILL KILLERS?</span></div>
<div> <br/></div>
<div class="cct"><span href="#/ande_9781118039977_oeb_c05_r1" title="Link target outside of Sample">CHAPTER FIVE - HOT-EST: WINNING WITH FASHION</span></div>
<div class="cct"><span href="#/ande_9781118039977_oeb_c06_r1" title="Link target outside of Sample">CHAPTER SIX - EASY-EST: WINNING WITH SOLUTION-ORIENTED SERVICE</span></div>
<div class="cct"><span href="#/ande_9781118039977_oeb_c07_r1" title="Link target outside of Sample">CHAPTER SEVEN - QUICK-EST: WINNING WITH FAST SERVICE</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c07_r1#h1" title="Link target outside of Sample">THE FUTURE FOR QUICK-EST LOOKS BRIGHT</span></div>
<div> <br/></div>
<div class="cct"><span href="#/ande_9781118039977_oeb_c08_r1" title="Link target outside of Sample">CHAPTER EIGHT - PUTTING EST TO WORK</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c08_r1#h1" title="Link target outside of Sample">GREENS FEES, PAR, AND EST</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c08_r1#h2" title="Link target outside of Sample">APPLYING EST</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c08_r1#h3" title="Link target outside of Sample">EST IN THE REAL WORLD</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c08_r1#h4" title="Link target outside of Sample">EST IN ACTION: BEST BUY AND COACH</span></div>
<div> <br/></div>
<div class="cpt"><span href="#/ande_9781118039977_oeb_p03_r1" title="Link target outside of Sample">PART III - The Future</span></div>
<div class="cct"><span href="#/ande_9781118039977_oeb_c09_r1" title="Link target outside of Sample">CHAPTER NINE - EST ISN’T FOREVER Retail Is Tougher Than Ever</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c09_r1#h1" title="Link target outside of Sample">CONSOLIDATION</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c09_r1#h2" title="Link target outside of Sample">COMPRESSED LIFE CYCLE</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c09_r1#h3" title="Link target outside of Sample">THREE’S A CROWD</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c09_r1#h4" title="Link target outside of Sample">FALLING OUT OF EST</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c09_r1#h5" title="Link target outside of Sample">MARKET SQUEEZE</span></div>
<div> <br/></div>
<div class="cct"><span href="#/ande_9781118039977_oeb_c10_r1" title="Link target outside of Sample">CHAPTER TEN - DEVELOPING TOMORROW’S HOT IDEAS</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c10_r1#h1" title="Link target outside of Sample">THE HOT ZONE</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c10_r1#h2" title="Link target outside of Sample">HOME-HAPPY BOOMERS</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c10_r1#h3" title="Link target outside of Sample">TWO APPROACHES TO GENERATION Y: GET THE PARENTS, GET THE KIDS</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c10_r1#h4" title="Link target outside of Sample">INCREASING ETHNIC DIVERSITY</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c10_r1#h5" title="Link target outside of Sample">HAVES AND HAVE-NOTS</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c10_r1#h6" title="Link target outside of Sample">LOOKING INSIDE FOR HOT IDEAS</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c10_r1#h7" title="Link target outside of Sample">GO WHERE THE CUSTOMERS ARE</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c10_r1#h8" title="Link target outside of Sample">WINNING RETAILERS ARE IN MOTION</span></div>
<div> <br/></div>
<div class="cct"><span href="#/ande_9781118039977_oeb_c11_r1" title="Link target outside of Sample">CHAPTER ELEVEN - PUTTING THE CUSTOMER IN CONTROL</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c11_r1#h1" title="Link target outside of Sample">RETAILER EFFICIENCY VERSUS CUSTOMER EFFICIENCY</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c11_r1#h2" title="Link target outside of Sample">THE FIVE CS OF PUTTING THE CUSTOMER IN CONTROL</span></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c11_r1#h3" title="Link target outside of Sample">CUSTOMERS IN CONTROL: GUIDELINES TO LIVE BY</span></div>
<div> <br/></div>
<div class="cct"><span href="#/ande_9781118039977_oeb_c12_r1" title="Link target outside of Sample">CHAPTER TWELVE - A GLANCE AT THE FUTURE</span></div>
<div> <br/></div>
<div class="ch1"><span href="#/ande_9781118039977_oeb_c12_r1#h1" title="Link target outside of Sample">FUTURE TRENDS</span></div>
<div> <br/></div>
<div class="cbmh"><span href="#/ande_9781118039977_oeb_nts_r1" title="Link target outside of Sample">NOTES</span></div>
<div class="cbmh"><span href="#/ande_9781118039977_oeb_in1_r1" title="Link target outside of Sample">INDEX</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ande_9781118039977_oeb_toc_r1.vue?2262652a